/* eslint-disable no-undef, camelcase  */
import { hydrateRoot } from 'react-dom/client';
import { Globals } from '@bwoty-web/ui-kit';
import * as ExponeaUtils from '../shared/utils/log/ExponeaUtils';
import HotelInfoView from '../shared/views/hotelInfo/hotelInfoView';

const initialStateHotelInfo = window.__INITIAL_STATE_HOTEL_INFO__;

/*
  Allow lazy load of components.
  Sets webpack publicPath for files during runtime, since the publicPath is different for each environment.
  Filepaths cannot be relative since the script is run on other domains.
*/
__webpack_public_path__ = `${initialStateHotelInfo?.siteSettings?.baseUrl}/static/`;

delete window.__INITIAL_STATE_HOTEL_INFO__;
const hotelInfoView = document.getElementById('hotel-info-view');

if (hotelInfoView) {
  const { hotelContent, siteSettings, isMixedHotel, hotelHasParts } =
    initialStateHotelInfo;
  hydrateRoot(
    hotelInfoView,
    <Globals
      siteId={siteSettings?.siteId}
      isMixedHotel={isMixedHotel}
      hotelHasParts={hotelHasParts}
    >
      <HotelInfoView {...initialStateHotelInfo} />
    </Globals>,
  );

  ExponeaUtils.logView(hotelContent);
}
